if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}

if (!customElements.get('gallery-media')) {
  customElements.define('gallery-media', class GalleryMedia extends HTMLElement {
    constructor() {
      super();
      this.thumbnails = this.querySelectorAll('.thumbnail-list__item');
      this.swiperContainer = this.querySelector('.main-swiper');
      this.swiper = null;
      this.thumbswiper = null;
      // document.addEventListener('DOMContentLoaded', this.init.bind(this))
      this.init();
    }
    init(){
      this.thumbswiper = new Swiper(".product-thumbnail-swiper", {
        spaceBetween: 3,
        slidesPerView: "auto",
        freeMode: true,
        watchSlidesProgress: true,
        direction: "vertical",
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
      });
      this.swiper = new Swiper( `.product-main-swiper`,{
        direction: 'horizontal',
        loop: false,
        slidesPerView: 1,
        centerInsufficientSlides: true,
        // loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          thumbs: {
            swiper: this.thumbswiper,
          },
      })
      // this.thumbswiper.on('slideChange', (swiper)=>{
      //   this.swiper.slideTo(swiper.activeIndex);
      // });
      let thumbnails = this.querySelectorAll('.thumbnail-list__item');
      thumbnails.forEach(th => th.addEventListener('click', ()=> {this.handleThumbnails(th)}))
    }
    
    handleSlideChange(index){
      const th = this.querySelector(`[data-media-position="${index+1}"]`);
      if(th.classList.contains('is_active')) return;
      this.handleThumbnails(th, false)
    }
    
    handleThumbnails(th, swipe=true){
      // let thumbnails = this.querySelectorAll('.thumbnail-list__item');
      // thumbnails.forEach(th => th.classList.remove('is_active'));
      // th.classList.add('is_active');
      if(this.swiper && swipe){
        this.swiper.slideTo(parseInt(th.getAttribute('data-media-position')) - 1);
      } 
    }
  });
}

// document.addEventListener('DOMContentLoaded', ()=>{
//   jQuery('gallery-media .product__media')
//     .zoom({magnify:2}); 
// })
// if (!customElements.get('gallery-media-wrapper')) {
//   customElements.define('gallery-media-wrapper', class GalleryMediaWrapper extends HTMLElement {
//     constructor() {
//       super();
//       this.galleryMedia = Array.from(this.querySelectorAll('gallery-media'));
//       this.productSelectUnsubscriber = subscribe(PUB_SUB_EVENTS.productSelect, (event) => {
//         this.setSelectionMedia(event.product.id)
//       });
//     }
//     connectedCallback(){
//     }
//     setSelectionMedia(productId){
//       this.galleryMedia.forEach(gallery => {
//         if(parseInt(gallery.dataset.product) == productId) return gallery.classList.remove('hidden');
//         return gallery.classList.add('hidden');
//       })
//     }
//   });
// }